import { render, staticRenderFns } from "./basicinfo.vue?vue&type=template&id=9c5678ae&scoped=true"
import script from "./basicinfo.vue?vue&type=script&lang=js"
export * from "./basicinfo.vue?vue&type=script&lang=js"
import style0 from "./basicinfo.vue?vue&type=style&index=0&id=9c5678ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5678ae",
  null
  
)

export default component.exports